import {Component, HostListener, Input, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {NgForOf, NgIf} from "@angular/common";
import {Pages} from "../../dto/Pages";
import {AccordionModule} from "primeng/accordion";
import {SafeHtmlPipePipe} from "../../pips/safe-html-pipe.pipe";
import {NumberTextPipe} from "../../pips/number-text.pipe";
import {DateTextPipe} from "../../pips/date-text.pipe";

@Component({
  selector: 'app-other-page',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    AccordionModule,
    SafeHtmlPipePipe,
    NumberTextPipe,DateTextPipe
  ],
  templateUrl: './other-page.component.html',
  styleUrl: './other-page.component.css'
})
export class OtherPageComponent extends TemplateComponent implements OnInit{
  @Input() pageType="PAGE";
  pageUID: string ;
  page:Pages = new Pages();
  indexList=[];
  topNavigationText:string="";
  dashboardInf:any;
  ngOnInit() {

      setTimeout(() => {
        try {
          this.dashboardInf = JSON.parse(this.global.getMainData()['dashboard']['data']);
        }catch (e){}


      }, 500)



    document.body.scrollTop = 0;
    this.pageUID = this.activeRoute.snapshot.paramMap.get("pageUid");
    if(this.route.url.startsWith("/feature")){
      this.pageType="FEATURE";
      this.topNavigationText = $localize`:@@Platform:Platform`;

    }
    else if(this.route.url.startsWith("/page")){
      this.pageType="PAGE";
      this.topNavigationText = $localize`:@@All Pages:All Pages`;
    }
    else if(this.route.url.startsWith("/blog")){
      this.pageType="BLOG";
      this.topNavigationText = $localize`:@@Blogs:Blogs`;
    }
    else if(this.route.url.startsWith("/news")){
      this.pageType="NEWS";
      this.topNavigationText = $localize`:@@News:News`;
    }
    else if(this.route.url.startsWith("/customer")){
      this.pageType="CUSTOMER";
      this.topNavigationText = $localize`:@@Customers:Customers`;
    }
    setTimeout(()=>{
      this.loadPage();
    },100)




  }
  loadPage() {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("lnd/site/get_page?" +
        "uid=" +this.pageUID+
        "&type="+this.pageType
    );
    observable.subscribe({
      next: (res: string) => {
        if (res["status"] == 200) {
          this.page = res["entity"];
          // console.log(this.attributFilterList);
          let temp= "";
          for (let tag of this.page.tags) {
           temp+=tag+",";
          }
          this.titleService.setTitle(this.page.name)
          this.meta.addTag({name:'keywords',content:temp},true);
          this.meta.addTag({name:'description',content:this.page.summary},true);

        }else if(res["status"] == 400) {
          this.route.navigate(['/'])
        }
        return res;
      },
      error: (e) => {
        this.messageService.clear();
        this.messageService.add({
              severity: 'error',
              summary: $localize`:@@Error:Error`,
              detail: $localize`:@@Server Timout Det:Server Timout Det`
            }
        );
      },
      complete: () => {
        this.global.progressBar = false;
        setTimeout(()=>{
          this.getSectionIndex();
        },200)

      }
    });
  }
//.......................................index menu...................
  @HostListener('body:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    let scrollTop = document.body.scrollTop;
    let windowHeight = window.innerHeight;
    let temp = false;
    let i=0;
    for (let elm of this.indexList) {
      let elmTop = document.getElementById(elm.id).offsetTop;
      let elmTopNext = i<this.indexList.length-1 ? document.getElementById(this.indexList[i+1].id).offsetTop : elmTop;
      if (elmTop > scrollTop && elmTop < scrollTop + windowHeight && !temp) {
        temp = true;
        document.getElementById("li_" + elm.id).classList.add("selected")
      } else if ( elmTopNext > scrollTop + windowHeight && !temp) {
        temp = true;
        document.getElementById("li_" + elm.id).classList.add("selected")
      } else {
        document.getElementById("li_" + elm.id).classList.remove("selected")
      }
      i++;
    }
  }
  getSectionIndex(){

    var elm = document.querySelectorAll<HTMLElement>(".section-title");
    elm.forEach((h2elm)=>{
      let temp = {id:h2elm.id,value:h2elm.innerText}
      this.indexList.push(temp);
    })
  }
  goToFregment(id: string) {
    if (document.getElementById(id)) {
      // @ts-ignore
      // document.getElementById(id).scrollIntoView({behavior: "smooth", block: 'start', inline: "nearest",onAnimationEnd: () => {}});
      // document.body.onscrollend = (e)=>{
      //   document.getElementById("li_"+id).classList.add("selected");
      //   if(window.innerWidth >768)
      //     document.body.scrollTo(0, document.getElementById(id).offsetTop-50);
      //   else
      //     document.body.scrollTo(0, document.getElementById(id).offsetTop-100);
      // }
      var headerOffset = 100;
      if(window.innerWidth >768)
        headerOffset=50;
      var elementPosition = document.getElementById(id).offsetTop;
      var offsetPosition = elementPosition  - headerOffset;

      document.body.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      for (let elm of this.indexList) {
        document.getElementById("li_"+elm.id).classList.remove("selected")
      }

      setTimeout(()=>{
        document.body.onscrollend = null;
      },1000)

    }

  }
  toggelSideIndex(sInx: HTMLDivElement) {
    if(sInx.classList.contains("hidden")){
      sInx.classList.remove("hidden");
    }else {
      sInx.classList.add("hidden");
    }

  }
  //................................................................................................

    goToPageList() {
      if (this.pageType == "FEATURE") {
        this.route.navigate(["/features"])
      } else if (this.pageType == "PAGE") {
        this.route.navigate(["/pages"])
      }else if (this.pageType == "BLOG") {
        this.route.navigate(["/blogs"])
      }else if (this.pageType == "NEWS") {
        this.route.navigate(["/all-news"])
      }
    }

  goToDashboard() {
    setTimeout(()=>{
      window.open(this.dashboardInf['loginUrl']);
    },200)

  }


  pageClick(event: MouseEvent, sInx: HTMLDivElement) {
    let temp: boolean = false;
    // @ts-ignore
    for (let childNode of document.getElementById('side-index').childNodes) {
      if (childNode == event.target) {
        temp = true;
        break;
      }
      for (let childNode1 of childNode.childNodes) {
        if (childNode1 == event.target) {
          temp = true;
          break;
        }
        for (let childNode2 of childNode1.childNodes) {
          if (childNode2 == event.target) {
            temp = true;
            break;
          }
        }
      }

    }
    if (!temp)
      sInx.classList.add("hidden");
  }
}
